import { render, staticRenderFns } from "./ContractEditor.vue?vue&type=template&id=01c476ac&scoped=true"
import script from "./ContractEditor.vue?vue&type=script&lang=js"
export * from "./ContractEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c476ac",
  null
  
)

export default component.exports